interface UrlOptions {
  isHttps?: boolean;
  removeTrailingSlash?: boolean;
}

export default class UrlUtils {
  static getExtensionFromFileUrl(url: string) {
    return url.split(/#|\?/)[0].split('.').pop()?.trim();
  }

  static FormatUrlQueryToString(query: Record<string, string>) {
    return Object.keys(query)
      .map((key) => `${key}=${(query as Record<string, string>)[key]}`)
      .join('&');
  }

  static startsWithProtocol(url: string) {
    return url.startsWith('http://') || url.startsWith('https://');
  }

  static GetFullUrl(url: string, options?: UrlOptions) {
    const { isHttps = false, removeTrailingSlash = false } = options || {};

    let convertedUrl = url;
    if (removeTrailingSlash) {
      convertedUrl = url.endsWith('/') ? url.slice(0, -1) : url;
    }

    return !this.startsWithProtocol(convertedUrl)
      ? `${isHttps ? 'https://' : 'http://'}${url}`
      : url;
  }

  static isLocalhost(): boolean {
    return Boolean(
      window.location.hostname === 'localhost' ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === '[::1]' ||
        // 127.0.0.1/8 is considered localhost for IPv4.
        window.location.hostname.match(
          /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
        ),
    );
  }
}

/**
 *
 * @param message receives a string message and parses it to HTML
 * @returns HTML string
 */
export const parseMessageToHTML = (message: string): string => {
  if (!message) {
    // if message is not set then return empty and skip parsing to HTML
    return '';
  }
  const linkRegex = /((https?:\/\/)?(www\.)?[^\s]+(?:\.\S+))/gi;
  const parsedHTML = message.replace(linkRegex, (match) => {
    const link = match.startsWith('http') ? match : `http://${match}`;
    return `<a href="${link}" target="_blank">${match}</a>`;
  });
  return parsedHTML;
};
